export default __webpack_public_path__ + "static/images/c550c6ee1e03239613c8ccada5901f1f.jpg";